import styled, { css } from 'styled-components';
import device from '@service-victoria/component-library/utils/device';
import colors from '@service-victoria/component-library/utils/colors';
import { Button } from '@service-victoria/component-library/components/Button';

export const IconsWrapper = styled.div`
  display: flex;
`;

export const FeedbackWrapper = styled.div`
  display: flex;
  flex-direction: column;
  @media ${device.isMobile} {
    align-items: center;
  }
`;

export const ButtonWrapper = styled(Button)`
  @media ${device.isDesktop} {
    width: 350px;
  }
`;

export const ThumbWrapper = styled.button<{ selected?: boolean; disabledStyle?: boolean }>`
  position: relative;
  height: 80px;
  width: 80px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 1px solid ${colors.blueGrey};
  border-radius: 1px;
  cursor: pointer;
  background: none;
  user-select: none;

  ${props =>
    props.disabledStyle &&
    css`
      background-color: ${colors.darkGrey10};
      border: 1px solid ${colors.darkGrey75};
      padding: 1px;
      span {
        color: #707070;
      }
    `}

  ${props =>
    props.selected &&
    css`
      border: 2px solid ${colors.orange};
      span {
        color: ${colors.orange};
      }
    `};

  &:first-child {
    margin-right: 20px;
  }

  &:active,
  &:focus {
    outline: none;
  }
`;

export const CircleTickWrapper: React.FC = styled.div`
  position: absolute;
  width: 20px;
  top: -8px;
  right: -8px;
`;
